import React, { Component, PureComponent } from 'react'

export function InfoGroup({ children }) {
  return <div className="form-info-group">{children}</div>
}

export default function Info({ label = false, text }) {
  return (
    <div className="form-info">
      {label ? <b className="info-label">{label}</b> : null}
      <span className="form-info-text">{text}</span>
    </div>
  )
}
